import styled from "styled-components";
import React, { PropsWithChildren, CSSProperties } from "react";
import { SiteLink } from "./atom";
import { Space } from "../space";
import LinkArrowIcon from "../../assets/svg/link-arrow";

export function Link({ type = "primary", ...props }: LinkProps) {
  const StyledLink = {
    primary: SiteLink,
    arrow: ArrowLink,
  }[type];
  return <StyledLink {...props} />;
}
export type LinkType = "primary" | "arrow";
export type LinkProps = PropsWithChildren<{
  href?: string;
  target?: string;
  rel?: string;
  fontSize?: number;
  color?: string;
  onClick?: () => void;
  type?: string;
  style?: CSSProperties;
  download?: string;
}>;

export function ArrowLink({ gap = 6, children, ...props }) {
  return (
    <SiteLink {...props}>
      <Space gap={gap} align="center">
        <span>{children}</span>
        <LinkArrowIcon />
      </Space>
    </SiteLink>
  );
}

export type ArrowLinkProps = PropsWithChildren<
  LinkProps & {
    gap?: number;
  }
>;
